import { SelectItem } from '@/components/ui/select'

/**
 * Picker dropdowns (schools / school-types / currencies) fetch a single
 * `page_size: 100` page. If the dictionary ever exceeds that, the rest is
 * invisible — so surface a disabled trailing item rather than truncating
 * silently (WO "no silent caps"). Renders nothing when the page is complete.
 */
export function LookupTruncationNote({ count, shown }: { count: number; shown: number }) {
  if (count <= shown) return null
  return (
    <SelectItem value="__truncated__" disabled>
      …pozostałe ({count - shown}) — zawęź wyszukiwaniem
    </SelectItem>
  )
}
